/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type UpcomingMaturitiesPaginatedProperty =
  typeof UpcomingMaturitiesPaginatedProperty[keyof typeof UpcomingMaturitiesPaginatedProperty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpcomingMaturitiesPaginatedProperty = {
  DUE_DATE: 'DUE_DATE',
  AMOUNT: 'AMOUNT',
} as const;
